export const environment = {
    api: 'https://api.futuroacs.com.br/api'
  };
  